import { useRef, useState, useEffect } from 'preact/hooks'

import Icon from '@/components/snippets/icon/icon'

import { SearchInput } from 'libs/searchspring/components/quick-search/SearchInput'
import { QuickSearchDropdown } from 'libs/searchspring/components/quick-search/QuickSearchDropdown'
import clsx from 'clsx'
import { SearchspringAutocompleteProvider } from 'libs/searchspring/fetchers/autocomplete'

// Extract common positioning classes to single variable for reuse on search input and dropdown
const searchPositionClasses = 'absolute top-full lg:top-0 left-0 right-0 lg:ml-28 lg:mx-4 lg:mr-64 lg:max-w-7xl search:ml-auto'

function QuickSearch() {
  const searchInputRef = useRef()
  const [inputValue, setInputValue] = useState()
  const [query, setQuery] = useState()
  const closeButtonRef = useRef()
  const modalRef = useRef()
  const [redirect, setRedirect] = useState(false)

  const handleFocusInput = () => {
    setTimeout(() => {
      searchInputRef.current.focus()
    }, 0)
  }

  const handleClose = (event) => {
    event.preventDefault()
    modalRef.current?.handleHide()
  }

  const handleUpdateValue = (event) => {
    setInputValue(event.target.value)
  }

  const resetInputValue = () => {
    setInputValue('')
    searchInputRef.current.value = ''
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setQuery(inputValue)
    }, 400)
    return () => {
      clearTimeout(timeout)
    }
  }, [inputValue])

  return (
    <x-modal data-id="search" data-body-lock className="z-0 flex items-center h-full group/search" ref={modalRef}>
      <button
        data-modal-role="open"
        data-modal-parent="search"
        type="button"
        aria-label="Open Search"
        className="flex justify-center h-full !rounded-none !rounded-l-sm z-1 hover:cursor-text xl-max:icon-lg xl:p-2 xl:px-3 xl:pr-0 xl:border-2 border-neutral-medium btn paragraph-md w-9 xl:w-40 bg-neutral-medium xl:bg-brand-white/80 xl:backdrop-blur-3xl btn-inline xl:justify-between animation-grow--left"
        onClick={handleFocusInput}
      >
        <span className="hidden pr-6 xl:block paragraph-sm text-neutral-secondary">Search</span>
        <Icon id="magnifying-glass" className="icon-lg" />
      </button>

      <form action="/search" method="get" className={clsx('search-container z-[51] justify-start hidden h-full group-data-visible/search:flex', searchPositionClasses)}>
        <div class="group-data-visible/search:animation-flex--shrink bg-transparent">
        </div>
        <div class="group-data-visible/search:animation-flex--grow group-data-visible/search:mr-[1px] relative lg-max:mt-[1px] overflow-hidden rounded-sm outline outline-1 bg-brand-white outline-brand-black">
          <SearchInput ref={searchInputRef} redirect={redirect} onInput={handleUpdateValue} />
          <div className={'absolute -translate-y-1/2 right-2 top-1/2 flex justify-end '}>
            {inputValue ? (
              <button className="underline btn btn-lg btn-inline text-input text-neutral-secondary"
              onClick={resetInputValue} type="reset"
              >
                Clear
              </button>
            ) : null}
            <button className="btn btn-lg btn-inline" aria-label="Close Search" type="button" data-modal-parent="search" data-modal-role="close" ref={closeButtonRef} onClick={handleClose}>
              <Icon id="close" />
            </button>
          </div>
        </div>
      </form>

      <div
        className={clsx('search-container top-full overflow-hidden opacity-0 max-h-0 delay-0 group-data-visible/search:delay-150 duration-300 transition-all z-40 flex flex-col pointer-events-none group-data-visible/search:pointer-events-auto group-data-visible/search:max-h-[min(calc(100dvh-(48px+32px)),670px)] group-data-visible/search:opacity-100', searchPositionClasses)}
      >
        <div className="flex flex-col h-full overflow-auto lg:overflow-hidden bg-brand-white">
          <SearchspringAutocompleteProvider runOnMount={false} resultsPerPage={4}>
            <QuickSearchDropdown query={query} redirect={redirect} setRedirect={setRedirect} />
          </SearchspringAutocompleteProvider>
        </div>
      </div>
      <button data-modal-parent="search" data-modal-role="close" className="fixed inset-0 hidden transition-all duration-300 opacity-0 pointer-events-none group-data-visible/search:block bg-neutral-black/30 backdrop-blur-lg group-data-visible/search:pointer-events-auto group-data-visible/search:opacity-100"></button>
      <div className={'hidden group-data-visible/search:lg-max:block absolute inset-0 bg-neutral-medium'}>
        <button className="" aria-label="Close Search" type="button" data-modal-parent="search" data-modal-role="close" onClick={handleClose}>
          <Icon id="close" className="icon icon-lg link" />
        </button>
      </div>
    </x-modal>
  )
}

export function WrappedQuickSearch() {
  return (
    <SearchspringAutocompleteProvider runOnMount={false}>
      <QuickSearch />
    </SearchspringAutocompleteProvider>
  )
}
